import axios from 'axios';
import { useUserStore } from '@/store/user/userStore';
import { useLayoutStore } from '@/store/layout/layoutStore';

const configureAxios = () => {
  axios.interceptors.request.use(
    async (config) => {
      if (!useLayoutStore().isSavingEnabled()) {
        console.warn(`Blocked API request to ${config.url} in view-only mode.`);
        return Promise.reject(
          new axios.Cancel('API disabled in view-only mode.')
        );
      }

      config.headers.Authorization = `Bearer ${await useUserStore().getAccessToken()}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      // errorHandler(error);
      return Promise.reject(error);
    }
  );
};

export { configureAxios };
